export const RESOURCE_ARTICLES = [
  {
    slug: "herramientas-digitales-medicos-geriatras-2026",
    category: "Tecnologia clinica",
    readTime: "8 min de lectura",
    title: "Las 5 mejores herramientas digitales para medicos geriatras en 2026",
    summary:
      "Una guia practica sobre herramientas que ayudan a ahorrar tiempo, mejorar la organizacion clinica y optimizar la atencion del adulto mayor.",
    intro:
      "La consulta geriatrica moderna requiere orden, velocidad y continuidad. Digitalizar procesos ya no es un lujo: es una forma concreta de dedicar mas tiempo a decidir y menos tiempo a tareas administrativas.",
    sections: [
      {
        heading: "Por que digitalizar la consulta geriatrica hoy",
        body: [
          "El perfil del paciente mayor suele incluir multimorbilidad, polifarmacia y seguimiento frecuente. Esto exige registrar mas informacion y compararla entre visitas.",
          "Cuando el proceso se mantiene manual o con herramientas separadas, aumenta el riesgo de duplicar trabajo y perder datos utiles para la toma de decisiones.",
        ],
      },
      {
        heading: "1) Historia clinica longitudinal",
        body: [
          "Una herramienta clinica debe permitir ver la evolucion del paciente en una sola linea de tiempo: antecedentes, diagnosticos, medicamentos y hallazgos clave.",
        ],
      },
      {
        heading: "2) Escalas geriatricas integradas",
        body: [
          "Aplicar escalas dentro del mismo flujo evita errores de transcripcion y acelera el analisis. Lo ideal es puntaje + interpretacion en tiempo real.",
        ],
      },
      {
        heading: "3) Documentacion clinica automatica",
        body: [
          "Generar informe clinico desde la consulta reduce carga administrativa y estandariza calidad documental.",
        ],
      },
      {
        heading: "4) Seguimiento de pacientes cronicos",
        body: [
          "Comparar consultas previas, alertas y tendencias facilita priorizar riesgos y ajustar planes de manejo sin revisar archivos dispersos.",
        ],
      },
      {
        heading: "5) Plataforma especializada en geriatria",
        body: [
          "Aurora Geriatrica destaca porque combina historia, escalas geriatricas e informe clinico automatico en un solo flujo pensado para medico geriatra.",
          "No se trata solo de digitalizar, sino de usar un software medico que entienda la complejidad real del adulto mayor.",
        ],
      },
    ],
    closing:
      "Elegir la herramienta adecuada impacta directamente en productividad y calidad clinica. Para geriatria, la especializacion importa.",
  },
  {
    slug: "automatizar-vgi-consulta-medica",
    category: "Valoracion geriatrica integral",
    readTime: "9 min de lectura",
    title: "Como automatizar la Valoracion Geriatrica Integral (VGI) en tu consulta medica",
    summary:
      "Pasos practicos para reducir tiempo administrativo y aplicar escalas geriatricas con mayor eficiencia.",
    intro:
      "En la consulta medica diaria, la valoracion geriatrica integral suele tomar mas tiempo del esperado: varias escalas geriatricas, notas dispersas e informe clinico manual al final. Para el medico geriatra, el problema no es la utilidad de la VGI, sino la friccion operativa para ejecutarla de forma consistente.",
    sections: [
      {
        heading: "Que es la VGI",
        body: [
          "La valoracion geriatrica integral es un enfoque clinico estructurado que evalua al adulto mayor en varias dimensiones: funcional, cognitiva, afectiva, nutricional, social y de riesgo.",
          "En la practica, suele apoyarse en instrumentos reconocidos: el Indice de Barthel para actividades basicas, la Escala de Lawton y Brody para actividades instrumentales, el Mini Mental de Folstein como tamizaje cognitivo habitual y la Escala de Yesavage para el estado de animo, ademas de otros criterios segun el paciente.",
          "Su objetivo es traducir informacion compleja en decisiones practicas para la consulta medica: priorizar problemas, ajustar plan y dar seguimiento con criterio.",
        ],
        image: "/resources/vgi-1.png",
        imageAlt: "Evaluación geriátrica digital en consulta médica",
      },
      {
        heading: "Problema actual: cuando la VGI se hace de forma manual",
        body: [
          "Cuando cada escala se aplica por separado y el puntaje se calcula fuera del flujo, la consulta se alarga y aumenta la carga administrativa.",
          "En ese escenario aparecen errores de transcripcion, informacion incompleta y dificultad para mantener el mismo estandar entre pacientes y entre visitas.",
          "El resultado frecuente: menos tiempo para analisis clinico y mas tiempo para tareas operativas.",
        ],
      },
      {
        heading: "Automatizacion: como un flujo digital simplifica la VGI",
        body: [
          "Un software medico orientado a geriatria permite seleccionar escalas, responder en pantalla y obtener interpretacion automatica en tiempo real.",
          "Asi, herramientas como el Indice de Barthel, la Escala de Lawton y Brody, el Mini Mental de Folstein o la Escala de Yesavage pueden aplicarse en secuencia dentro del mismo expediente, sin recalcular a mano ni copiar resultados entre archivos.",
          "Con ello, la consulta mantiene continuidad: escalas, hallazgos y recomendaciones quedan en un mismo flujo clinico.",
          "Ademas, la salida documental se acelera: el informe clinico se genera con estructura clara y listo para imprimir o compartir.",
        ],
        image: "/resources/vgi-2.png",
        imageAlt: "Software médico con escalas geriátricas automatizadas",
      },
      {
        heading: "Evaluacion rapida (VGI): valor practico inmediato",
        body: [
          "En jornadas con alta demanda, una modalidad de evaluacion rapida permite aplicar escalas sin crear paciente desde el inicio.",
          "Esto facilita tamizajes clinicos, interconsultas o valoraciones iniciales sin frenar la agenda.",
          "Luego, si el caso lo requiere, esa evaluacion puede convertirse en consulta completa con trazabilidad.",
        ],
      },
      {
        heading: "Beneficios clinicos reales para la consulta medica",
        body: [
          "Menos tiempo administrativo: se reduce el retrabajo de puntuar y redactar manualmente.",
          "Mejor toma de decisiones: el medico ve resultados e interpretaciones en contexto, durante la consulta.",
          "Mayor claridad clinica: informacion estructurada, comparable y util para seguimiento de pacientes cronicos.",
          "Enfoque practico: la tecnologia apoya el criterio medico, no lo reemplaza.",
        ],
      },
    ],
    closing:
      "Automatizar la valoracion geriatrica integral no significa perder profundidad. Significa ganar tiempo clinico real para pensar mejor cada decision y atender mejor al adulto mayor.",
    preCtaImage: "/resources/vgi-3.png",
    preCtaImageAlt: "Médico revisando informe clínico con paciente adulto mayor",
    ctaTitle: "Organice el expediente geriátrico con Aurora",
    ctaBullets: [
      "Expediente geriátrico organizado",
      "Agenda clínica y seguimiento",
      "Informes clínicos personalizables",
    ],
  },
  {
    slug: "gestionar-pacientes-cronicos-clinicas-latam",
    category: "Gestion clinica LATAM",
    readTime: "9 min de lectura",
    title: "Como gestionar pacientes cronicos en clinicas de Latinoamerica",
    summary:
      "Claves para organizar mejor el seguimiento, reducir carga administrativa y mejorar la continuidad clinica.",
    intro:
      "En muchas clinicas de Latinoamerica, el principal reto no es diagnosticar: es sostener seguimiento ordenado en pacientes cronicos con alta demanda asistencial.",
    sections: [
      {
        heading: "Problemas frecuentes en la region",
        body: [
          "Historia clinica fragmentada, tiempos cortos de consulta, procesos manuales y dificultad para comparar evolucion entre visitas.",
          "Esto afecta continuidad y complica decisiones en pacientes con multiples condiciones.",
        ],
      },
      {
        heading: "Lo que mas ayuda en la practica",
        body: [
          "1) Un expediente unico y claro.",
          "2) Escalas clinicas que se apliquen dentro del flujo habitual.",
          "3) Documentacion rapida para no atrasar la agenda.",
        ],
      },
      {
        heading: "Orden y seguimiento como ventaja clinica",
        body: [
          "Cuando la informacion esta estructurada, el medico identifica cambios relevantes mas rapido y puede anticipar riesgos.",
          "Esto mejora calidad de atencion y reduce retrabajo administrativo del equipo.",
        ],
      },
      {
        heading: "Soluciones digitales simples y sostenibles",
        body: [
          "No hace falta complejidad tecnologica extrema. Lo importante es que el software medico resuelva tareas diarias de forma consistente.",
          "Aurora Geriatrica esta orientada a ese objetivo: consulta estructurada, valoracion geriatrica integral y salida documental lista en una sola plataforma.",
        ],
      },
    ],
    closing:
      "Gestionar cronicos en LATAM requiere metodo, no mas carga. Una plataforma enfocada en geriatria ayuda a sostener continuidad clinica real.",
  },
  {
    slug: "escalas-geriatricas-guia-practica",
    category: "Escalas geriatricas",
    readTime: "10 min de lectura",
    title: "Guia practica de escalas geriatricas para medicos y estudiantes",
    summary:
      "Una referencia clara para aplicar escalas geriatricas en consulta medica, estudio clinico y valoracion geriatrica integral sin perder tiempo.",
    intro:
      "En geriatria hay muchas escalas y no siempre es facil recordarlas en el momento correcto. Entre consulta medica, guardias y practica academica, el tiempo suele ser corto. Esta guia practica resume las escalas geriatricas clave para que puedas usarlas con criterio clinico y fluidez.",
    sections: [
      {
        heading: "Que son las escalas geriatricas",
        body: [
          "Las escalas geriatricas son herramientas clinicas que ayudan a evaluar areas especificas del adulto mayor de forma ordenada y comparable.",
          "No reemplazan el juicio del medico geriatra ni del medico general. Su valor esta en transformar hallazgos en decisiones mas claras durante la valoracion geriatrica integral.",
        ],
        image: "/resources/escalas-1.png",
        imageAlt: "Evaluación clínica con escalas geriátricas",
      },
      {
        heading: "Escalas mas importantes para la practica diaria",
        body: [
          "Indice de Barthel: evalua actividades basicas de la vida diaria, como higiene, movilidad y alimentacion. Es util cuando necesitas estimar dependencia funcional y planear apoyos inmediatos.",
          "Escala de Lawton y Brody: evalua actividades instrumentales, por ejemplo manejo de medicacion, telefono, compras y finanzas. A diferencia de Barthel, se enfoca en autonomia funcional mas compleja para vida en comunidad.",
          "Mini Mental de Folstein: mide orientacion, memoria, atencion y lenguaje como tamizaje cognitivo. Se usa cuando hay sospecha de deterioro cognitivo o para seguimiento de cambios en el tiempo.",
          "Escala de Yesavage: evalua sintomas depresivos en el adulto mayor y facilita deteccion temprana de depresión en consulta medica, especialmente cuando el cuadro afectivo puede pasar desapercibido.",
        ],
        image: "/resources/escalas-2.png",
        imageAlt: "Escalas médicas digitales en software clínico",
      },
      {
        heading: "Problema real en la practica",
        body: [
          "En muchos entornos, estas escalas se aplican por separado, con formatos distintos y sin integracion entre resultados.",
          "Eso consume tiempo, favorece omisiones de pasos y dificulta tener una lectura clinica global en la misma consulta medica.",
          "Al final, el equipo dedica mas energia a tareas operativas que al analisis clinico del paciente.",
        ],
      },
      {
        heading: "Como simplificar su uso en consulta",
        body: [
          "Una forma practica es trabajar en un flujo unico: aplicar escalas geriatricas, obtener puntajes y revisar interpretacion en la misma pantalla.",
          "Con apoyo de software medico, se evita duplicar datos entre hojas o sistemas y se reduce el riesgo de errores de transcripcion.",
          "Ademas, los resultados quedan organizados para seguimiento clinico y para documentar mejor cada valoracion geriatrica integral.",
        ],
      },
      {
        heading: "Beneficios clinicos al integrar escalas",
        body: [
          "Rapidez: menos tiempo en calculo manual y mas tiempo en entrevista y examen clinico.",
          "Claridad: resultados estructurados para comparar evolucion entre visitas.",
          "Organizacion: informacion funcional, cognitiva y afectiva en un mismo expediente.",
          "Mejor toma de decisiones: el contexto completo facilita priorizar problemas y ajustar manejo.",
        ],
      },
    ],
    closing:
      "En geriatria, no se trata solo de saber mas escalas, sino de trabajar mejor con ellas. Cuando el proceso es claro, la decision clinica tambien mejora.",
    preCtaImage: "/resources/escalas-3.png",
    preCtaImageAlt: "Médico utilizando herramientas digitales en consulta",
    ctaTitle: "Organice consultas e historial con Aurora",
    ctaBullets: [
      "Consulta geriátrica estructurada",
      "Seguimiento longitudinal",
      "Informes clínicos personalizables",
    ],
  },
];

export const getResourceBySlug = (slug) => RESOURCE_ARTICLES.find((article) => article.slug === slug);
